<template>
  <div class="collapsible-section">
    <!-- Divider + clickable header -->
    <div class="collapsible-header" @click="toggle" :aria-expanded="open.toString()">
      <span class="collapsible-title">{{ title }}</span>
      <md-icon class="collapsible-chevron">{{ open ? 'expand_less' : 'expand_more' }}</md-icon>
    </div>
    <transition name="collapsible-fade">
      <div v-show="open" class="collapsible-body">
        <slot></slot>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'CollapsibleSection',
  props: {
    title: { type: String, default: '' },
    // Start open by default; pass :defaultOpen="false" to start collapsed.
    defaultOpen: { type: Boolean, default: true }
  },
  data() {
    return {
      open: this.defaultOpen
    };
  },
  methods: {
    toggle() {
      this.open = !this.open;
    }
  }
};
</script>

<style scoped>
.collapsible-section {
  border-top: 2px solid #e3e3e3;
  margin-top: 1rem;
}
.collapsible-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  padding: 1rem 0.5rem;
  cursor: pointer;
  user-select: none;
}
.collapsible-header:hover {
  background: #f5f5f5;
}
.collapsible-chevron {
  flex-shrink: 0;
}
.collapsible-title {
  font-size: 1.15rem;
  font-weight: 600;
  color: #333;
}
.collapsible-body {
  padding: 0.5rem 0 1rem;
}
.collapsible-fade-enter-active,
.collapsible-fade-leave-active {
  transition: all .18s cubic-bezier(.4,0,.2,1);
}
.collapsible-fade-enter,
.collapsible-fade-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}
</style>
